import ResidentialVerificationModal from './residential-verification-modal';

export default ResidentialVerificationModal;
